import React, { Component } from 'react';
import png23andMe from "./images/buttons/png23andMe.png";
import './loadSpinner.css';

class Google extends Component {
  state = {
    filesize_checked:false,
    filesize:""
  }
  
  getUploadButton = () => {
    if (this.props.credential == null) {
      return <>
        Once you authenticate using Google login, the 23andMe file can be uploaded with the form below.<br/><br/>
        <img alt="upload" src="https://moreygenetics.com/images/upload/upload.png"/>
      </>;
    }
    let upload = <form target="_blank" action='https://moreygenetics.com/upload_google.py' method='post' encType='multipart/form-data'>
      <input name='file' type='file'/><br/><input type='submit' value='&#x2B06;&#xfe0f; Upload file'/>
      <input name='credential' type='hidden' value={this.props.credential}/>
      <a href='http://you.23andme.com/tools/data/download/'>
        <img style={{width:"55px",margin:"0px 50px"}} src={png23andMe} alt="23andMe" />
      </a>
    </form>;
    if (this.state.filesize_checked && this.state.filesize != "0 B") {
      return <>
        <span role='img' aria-label='(File)'>&#x1f4cb;&nbsp;</span>
        {this.state.filesize}<br/><br/>
        You&apos;ve already uploaded a file, but if you choose to use a different one - such as a more recent download - you can still use the form below to replace it.<br/><br/>
        It will replace your current upload and will not keep both files.<br/><br/>
        {upload}
      </>;    
    } else {
      return upload;
    }
  };
  
  getDeleteButton = () => {
    if (this.props.credential == null) {
      return <>
        You are not logged in with any Google account.  Once you have logged in and uploaded a file, the button below may be used to delete all saved data.
        <br/><br/>
        <button>
          <span role='img' aria-label='(Trash)'>&#x1f5d1;&#xfe0f;</span>
          0 B - Nothing to delete
        </button>
      </>;
    }
    if (!this.state.filesize_checked) {      
      let url = "https://moreygenetics.com/api/filesize.py";
      url += "?credential=" + this.props.credential;
      console.log(url);
      fetch(url)
        .then(res => res.text())
        .then(
          (result) => {
            this.setState({
              filesize_checked:true,
              filesize:result
            });
          },
          (error) => {
            console.log(error)
          }
        )
      return <>Logged in, checking the file size<br/><br/><button><span role='img' aria-label='(Trash)'>&#x1f5d1;&#xfe0f;</span> ...</button></>;
    }
    if (this.state.filesize === "0 B") {
      return <button>
        <span role='img' aria-label='(Trash)'>&#x1f5d1;&#xfe0f;</span> 0 B - Nothing to delete
      </button>;
    } else {
      return <button onClick={()=>{
        window.document.getElementById('spinner-overlay').style.display = '';
        fetch('https://moreygenetics.com/api/delete_google_data.py', {
          method:'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({credential:this.props.credential})
        })
        .then(r=>r.text())
        .then(
          (r)=>{
            alert(r);
            this.setState({
              filesize_checked:false
            });
            window.document.getElementById('spinner-overlay').style.display = 'none';
          },
          (error)=>{
            console.log(error);
          }
        )
      }}>
        <span role='img' aria-label='(Trash)'>&#x1f5d1;&#xfe0f;</span>
        {this.state.filesize}
      </button>;
    }
  }
  
  componentDidMount() {
    if (this.props.headerBtnVisible) {this.props.removeHeaderBtn()};
  }

  render() {
    return (
      <>
        <div id='spinner-overlay' style={{display:'none'}}>
          <div id='spinner'></div>
        </div>
        <a href='https://moreygenetics.com'>
          <span style={{fontSize:'35px'}}>&#x1F844;</span>
        </a>
        <h1>Authentication, file upload, and deletion instructions</h1>
        <h2>
          {this.props.credential&&<span role='img' aria-label='(Done)'>&#x2705;&#xfe0f;&nbsp;</span>}
          Step 1 : Authenticate with Google
        </h2>
        {this.props.googleButton
        //{this.props.token ? logoutButton : loginButton}
        }
        <h2>
          {
            this.state.filesize_checked&&
            (this.state.filesize!=="0 B")&&
            <span role='img' aria-label='(Done)'>&#x2705;&nbsp;</span>
          }
          Step 2 : Download data file from 23andMe
        </h2>
          The URL below can be used to download the raw data file from 23andMe.com<br/><br/>
          <a href='https://you.23andme.com/tools/data/download/' target="_blank" rel="noopener noreferrer">
            <span role='img' aria-label="Download">&#x2b07;&#xfe0f;</span>&nbsp;
            https://you.23andme.com/tools/data/download/
            <br/><br/>
            <div className="login-image-flex">
              <img style={{width:"35%"}} alt="login" src="https://moreygenetics.com/images/upload/login.png"/>
              <img style={{width:"30%"}} alt="download" src="https://moreygenetics.com/images/upload/download.png"/>
              <img style={{width:"35%"}} alt="submit" src="https://moreygenetics.com/images/upload/submit.png"/>
            </div>
          </a>
        <h2>
          {
            this.state.filesize_checked&&
            (this.state.filesize!=="0 B")&&
            <span role='img' aria-label='(Done)'>&#x2705;&#xfe0f;&nbsp;</span>
          }
          Step 3 : Upload the file to server
        </h2>
        {this.getUploadButton()}
        
        <h2>Data deletion instructions</h2>
        If you have any issues using the delete button, please email <a href='mailto:kevin.a.morey@gmail.com'>Kevin Morey</a><br/><br/>
        {this.getDeleteButton()}
      </>
    );
  }
}

export default Google;